import { FiArrowUpRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import styles from './Portfolio.module.css';

const ProjectCard = ({ project }) => (
  <article className={styles.projectCard}>
    <Link to={`/projects/${project.slug}`} className={styles.projectCardLink}>
      <div className={styles.projectCardMeta}>
        <span>{project.year}</span>
        <span>{project.label}</span>
      </div>
      <div className={styles.projectCardBody}>
        <div className={styles.projectCardTitleRow}>
          <h3>{project.name}</h3>
          <FiArrowUpRight aria-hidden="true" />
        </div>
        <p>{project.summary}</p>
        <div className={styles.tagList}>
          {(project.technologies || []).slice(0, 5).map((technology) => <span key={technology}>{technology}</span>)}
        </div>
      </div>
      {project.coverImage && (
        <img className={styles.projectCover} src={project.coverImage} alt={`${project.name} project preview`} loading="lazy" />
      )}
    </Link>
  </article>
);

export default ProjectCard;
